import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ChatbotWidget from "./ChatbotWidget";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-zinc-950">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ChatbotWidget />
    </div>
  );
}
